<template>
    <div id="search-list-view" class="search-list-view search-view">
        <div class="list-head-info">
            <div class="city">{{city}}</div>
            <div class="qty">{{resultsString}}</div>
        </div>
        <div v-if="itemsLoaded" class="properties-wrapper">
            <property-details
                    v-for="property in properties"
                    :key="property.id"
                    :property="property"
                    @imageLoaded="increaseCounter()"
            />
        </div>
        <div v-else class="text-center">
            <font-awesome-icon :icon="getSocialIcon('spinner')" size="2x" spin/>
        </div>
    </div>
</template>

<script>
    import PropertyDetails from './PropertyDetails';
    import {MapEventHub} from './MapEventHub'
    import {faSpinner} from '@fortawesome/pro-light-svg-icons/faSpinner';

    export default {
        name:'PropertiesListView',
        components: {PropertyDetails},
        props: {
            properties: {
                type: Array,
                default: Array
            },
            filters: Object,
        },
        data(){
            return {
                showItems: false,
                socialIcons: {
                    faSpinner,
                },
                imageLoadedCounter: 0,
            }
        },
        computed: {
            propertiesCount() {
                return this.properties.length;
            },
            city() {
                return this.filters && this.filters.city || 'All';
            },
            itemsLoaded() {
                return !MapEventHub.idle;
            },
            resultsString() {
                let plural = this.propertiesCount === 1 ? 'Community' : 'Communities';

                return `${this.propertiesCount} Apartment ${plural}`;
            }
        },
        methods: {
            getSocialIcon(network) {
                switch (network) {
                    case 'spinner':
                        return this.socialIcons.faSpinner;
                    default:
                        return this.socialIcons.faSpinner;
                }
            },
            animateProperties() {
                TweenMax.staggerFromTo('#search-list-view .property-item', 0.5, {y: 100, opacity: 0}, {y: 0, opacity: 1}, 0.1);
            },
            increaseCounter() {
                console.log('loaded');
                if(++this.imageLoadedCounter === this.propertiesCount){
                    MapEventHub.idle = false;
                    this.animateProperties();
                }
            },
        },
        watch: {
            itemsLoaded: {
                deep: true,
                handler() {
                    this.$nextTick(() => {
                        this.animateProperties();
                    });
                }
            }
        }
    }
</script>

<style lang="scss" type="text/scss">
    .search-list-view {
        width: 100%;
        background: #fff;

        .property-item{
            opacity: 1;
            display: flex;
            justify-content: space-between;

            .availability{
                text-align: left;
            }

            .property-body{
                margin-bottom: 15px;
                line-height: 24px;
                min-height: 120px;
            }

            .col-1{
                background: #f3f3f3;
                width: 270px;
            }

            .col-2{
                width: calc(100% - 300px);
            }
        }
    }
</style>
